import { render, staticRenderFns } from "./overage.vue?vue&type=template&id=8a98b404&scoped=true&"
import script from "./overage.js?vue&type=script&lang=js&"
export * from "./overage.js?vue&type=script&lang=js&"
import style0 from "./overage.vue?vue&type=style&index=0&id=8a98b404&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a98b404",
  null
  
)

export default component.exports